var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8c0 4.411 3.589 8 8 8s8-3.589 8-8c0-4.411-3.589-8-8-8s-8 3.589-8 8zM30.222 32h1.778v-1.778c0-6.861-5.333-12.445-16-12.445s-16 5.333-16 12.445v1.778h30.222z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.4042295ccd77c0cba8e057f882577571.svg";
export { ForwardRef as ReactComponent };